/**
 *
 * @param referrer { document.referrer } // e.x. https://www.exmaple.com/
 * @return {
 *          lead_source_id: string,
 *          lead_source_id_ext?: string
 *      }
 */
export const calculateReferrer = (referrer: string): {
    lead_source_id: string,
    lead_source_id_ext?: string
} => {
    if (!referrer) {
        return {
            lead_source_id: 'undefined'
        }
    }
    // get hostname from referrer url - split by / && rm www. - result -> domain.com
    let referrerHostname = referrer.split('/')[2].replace('www.', '');

    const searchSites = {
            'yandex.ru': 'yandex',
            'google.com': 'google',
            'bing.com': 'bing', // ok
            'xn--80aforc.xn--p1acf': 'nigma', // ok
            'mail.ru': 'mail', // в поиске mail.ru - реферер яндекс 🤷🏼‍ - пробрасывают через yandex.ru/clck
            'rambler.ru': 'rambler', // при переходе из поисковика хост тот что ниже, этот не встречался
            'nova.rambler.ru': 'rambler', // ok
            'yahoo.com': 'yahoo', // при переходе из поисковика хост тот что ниже, этот не встречался
            'r.search.yahoo.com': 'yahoo', // ok
        },
        isReferrerGibdd = referrerHostname === 'xn--90adear.xn--p1ai';
    if (isReferrerGibdd) {
        return {
            lead_source_id: 'gibdd'
        }
    }
    return {
        lead_source_id: 'search',
        lead_source_id_ext: searchSites[referrerHostname] || 'undefined'
    }
}
